import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { runtime } from '../../../classes/runtime/Runtime';
export class ConditionsMultipleChoiceGap extends ConditionRegistryCategory {
    label = 'Gap';
    constructor(parent) {
        super(parent);
        super.init();
    }
    gapShouldBeFilledWithDefault = () => new ConditionRegistryItem({
        parent: this,
        label: 'GapShouldBeFilledWithDefault',
        eval: ({ questionMultipleChoice, gap }) => {
            if (!(questionMultipleChoice instanceof runtime.class.Choice))
                return false;
            if (!gap)
                return false;
            if (gap.ownAspect.reveal.persistentAspect.aspectContent.local.contentTraits.length > 0)
                return false;
            if (!questionMultipleChoice.choiceEval.isComplete)
                return false;
            return true;
        }
    });
}
